<template>
  <div id="doctor-map-panel-container" ref="container" :data-testid="TestId.finder.mapPanel" :aria-busy="loading">
    <p v-if="empty" class="no-results-message">{{ payload.no_results_message }}</p>
    <div v-else class="doctor-panel-list">
      <sp-finder-appointment-date-selector
        placement="map"
        style="position: sticky; top: var(--finder-map-header-offset)"
      ></sp-finder-appointment-date-selector>
      <FinderResultCard
        v-for="{ result, tag, properties } in cards"
        :key="result.resultGUID"
        class="doctor-panel"
        :class="cardModifiers(result)"
        :tag="tag"
        :result="result"
        :properties="properties"
        @mouseenter="highlight(result.resultGUID)"
        @mouseleave="unhighlight(result.resultGUID)"
      />
      <FinderMapPagination
        v-if="payload"
        :payload="payload"
        :commands="commands"
        :viewport="viewport"
        :map-settings="mapSettings"
        :bounds="params?.bounds"
      />
    </div>
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { TestId } from "#/test-ids";
import { useFinderMapSidebar } from "#ce/apps/SpFinderMap/composables/useFinderMapSidebar";
import FinderResultCard from "#ce/components/SpFinder/components/FinderResultCard.ce.vue";
import FinderMapPagination from "./FinderMapPagination.ce.vue";
const props = defineProps({
  records: { type: Array, default: undefined },
  kind: { type: Object, default: undefined },
  payload: { type: Object, default: undefined },
  settings: { type: Object, default: undefined },
  loading: Boolean,
  params: { type: Object, default: undefined },
  commands: { type: Object, default: undefined },
  viewport: { type: Object, default: undefined },
  mapSettings: { type: Object, default: undefined },
  selectedGuid: { type: String, default: undefined },
});
const emit = defineEmits(["highlight", "unhighlight"]);
const { empty, cards, cardModifiers, highlight, unhighlight } = useFinderMapSidebar(
  props,
  emit,
  useTemplateRef("container"),
);
</script>
